import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../lib/api';
import { useAuth } from './AuthContext';

const SupportNotifContext = createContext({ unreadCount: 0, refresh: () => {} });

export function SupportNotifProvider({ children }) {
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!user) { setUnreadCount(0); return; }
    try {
      const res = await api.get('/support/tickets');
      const tickets = res.data?.tickets || [];
      // Count tickets where read_by_user is false (admin replied and user hasn't opened it yet)
      const count = tickets.filter(t => t.read_by_user === false).length;
      setUnreadCount(count);
    } catch {
      // silent
    }
  }, [user]);

  useEffect(() => {
    refresh();
    // Re-check every 2 minutes (light server load)
    const interval = setInterval(refresh, 2 * 60 * 1000);
    // Also refresh when user returns to tab
    const onFocus = () => refresh();
    window.addEventListener('focus', onFocus);
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', onFocus);
    };
  }, [refresh]);

  return (
    <SupportNotifContext.Provider value={{ unreadCount, refresh }}>
      {children}
    </SupportNotifContext.Provider>
  );
}

export function useSupportNotif() {
  return useContext(SupportNotifContext);
}
